if(!customElements.get('floating-button')) {
  customElements.define('floating-button',
    class FloatingButton extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        window.addEventListener('scroll', (e) => {
          if(window.scrollY > 50) {
            this.classList.add('show');
          }
        });
      }
    }
  )
}